export enum BrushSectionTypeEnum {
    Part = 0,
    Assembly = 1,
}

export enum SectionTabEnum {
    Material = 0,
    Cores = 1,
    TopBrush = 2
}